<div class="bmark-summary__hedge-orders__container">
  <div
    class="bmark-summary__hedge-orders__body"
    style="display: flex; flex-direction: row; align-items: stretch"
  >
    <bmark-hedge-orders-blotter
      style="display: flex; flex-direction: column; flex: 1 1 auto"
      #bmarkHedgeOrders
      [orderIDsFromInput]="orderIds"
      [publishGridDataUpdateInfo]="true"
    ></bmark-hedge-orders-blotter>
  </div>
</div>
